import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Guardian on users {
    user_id
    user_first_name
    user_last_name
    user_phone
    user_email
  }
  fragment User on users {
    user_id
    id: user_id
    sub: user_cognito_sub
    user_email
    user_phone
    user_pic  
    fname: user_first_name
    lname: user_last_name
    gender_pronounce
    user_preferred_name
    state
    timezone
  }
  fragment StudentProfile on student_profile {
    id
    user_id
    highschool_info
    parent_info
    personal_info
    college_info
    immigration_details
    is_trial
    onboarding_done
    application_progress
    trial_end_date  
    lc_id
    lc_user {
      user_first_name
      user_last_name
      user_pic
      user_cognito_sub
      user_email
      user_type
      profile: lc_profiles {
        bio
      }
    }
    hc_id
    hc_user {
      user_first_name
      user_last_name
      user_pic
      user_cognito_sub
      user_email
      user_type  
      profile: hc_profiles {
        bio
      }
    }
    fa_id
    fc_user {
      user_first_name
      user_last_name
      user_pic
      user_cognito_sub
      user_email
      user_type
      profile: fc_profiles {
       bio
      }
    }
    financial_aid_settings  
    admin {
        user_id
        user_first_name
        user_last_name
        user_pic 
    }  
    product_type
    user {
      ...User
    }
    group {
      group_id
      group {
        name
      }
    }
    curriculum_id
  }
`;

export const GET_STUDENT_PROFILE = gql`
  query getUserProfile($id: Int) {
    student_profile(where: { user_id: { _eq: $id } }) {
      ...StudentProfile
      guardians {
        relationship
        education_level
        colleges
        guardian {
          user_id
          user_first_name
          user_last_name
          user_email
          user_phone
        }
      }
      subscriptions(order_by: {created_at: desc}) {
          id
          status
          end_date
          plan_id
          product {
              pricing_model
          }
      }  
    }
  }
  ${FRAGMENT}
`;

export const GET_PARENT_STUDENT = gql`
  query get($userId:Int!) {
    rows: student_guardians(where:{guardian_id:{_eq:$userId}}) {
      student_id
      student {
        user_first_name
      }
      student_profile {
        admin_id
        product_type
      }
    }
  }
`;

export const UPDATE_STUDENT_PROFILE = gql`
  mutation update($id: Int, $input: student_profile_set_input) {
    update_student_profile(where: { user_id: { _eq: $id } }, _set: $input) {
      returning {
        ...StudentProfile
        guardians {
          guardian {
            user_first_name
            user_last_name
            user_email
            user_phone
          }
        }
      }
    }
  }
  ${FRAGMENT}
`;

export const GET_GUARDIANS = gql`
  query getGuardians($userId: Int!) {
    guardians: student_guardians(
      where: { student_id: { _eq: $userId } }
      limit: 2
    ) {
      id
      guardian_id
      relationship
      education_level
      colleges
      guardian {
        ...Guardian
      }
    }
  }
  ${FRAGMENT}
`;

export const ADD_GUARDIAN = gql`
  mutation addGuardian(
    $firstName: String!
    $lastName: String!
    $email: String!
    $phone: String
    $studentId: Int!
    $relationship: String! 
  ) {
    insertGuardian(
      email: $email
      phone: $phone
      first_name: $firstName
      last_name: $lastName
      studentId: $studentId
      relationship: $relationship
    ) {
      user_id
      user_first_name
      user_last_name
      user_phone
      user_email
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_GUARDIAN = gql`
         mutation updateUser(
           $userId: Int!
           $relationshipInfo: student_guardians_set_input
           $data: users_set_input
         ) {
           update_users(where: { user_id: { _eq: $userId } }, _set: $data) {
             returning {
               ...Guardian
             }
           }
           update_student_guardians(
             where: { guardian_id: { _eq: $userId } }
             _set: $relationshipInfo
           ) {
             returning {
               id
               guardian_id
               relationship
               education_level
               colleges
               guardian {
                 ...Guardian
               }
             }
           }
         }
         ${FRAGMENT}
       `;
